import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@alm/flow-ds/components";

import { ElementLayoutFieldProps } from "./types";

const LastElement = ({
	id,
	value,
	field,
	elementIndex,
	updateStore,
}: ElementLayoutFieldProps) => {
	const [lastElement, setLastElement] = useState<boolean>(
		value?.lineBreakAfterElement || false
	);

	const { t } = useTranslation();

	const onChange = useCallback(() => {
		setLastElement(!lastElement);
		updateStore({
			elementIndex,
			property: field,
			value: { ...value, lineBreakAfterElement: !lastElement },
		});
	}, [elementIndex, field, lastElement, updateStore, value]);

	return (
		<Checkbox
			id={`last-element-${id}`}
			label={t("formDesigner.labels.lastElement")}
			onChange={onChange}
			value={lastElement.toString()}
			checked={lastElement}
		/>
	);
};

export default React.memo(
	LastElement,
	(prevProps, nextProps) =>
		prevProps.value?.proportionalWidth ===
			nextProps.value?.proportionalWidth &&
		prevProps.value?.lineBreakAfterElement ===
			nextProps.value?.lineBreakAfterElement
);
